import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "text-center text-danger my-2 pt-5" }
const _hoisted_2 = { class: "d-none d-md-block text-center" }
const _hoisted_3 = { style: {"position":"relative","width":"70%","left":"20%"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "table-container" }
const _hoisted_7 = ["title"]
const _hoisted_8 = {
  key: 0,
  class: "multiselect__single"
}
const _hoisted_9 = {
  key: 1,
  class: "multiselect__single"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["href"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["title"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["href"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["href"]
const _hoisted_19 = { style: {"white-space":"pre"} }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["href"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["href"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["href"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "float-end" }
const _hoisted_29 = { class: "float-end" }
const _hoisted_30 = { class: "column-name" }
const _hoisted_31 = ["href"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "float-end" }
const _hoisted_34 = {
  key: 0,
  class: "float-end"
}
const _hoisted_35 = { class: "float-end" }
const _hoisted_36 = {
  key: 0,
  class: "float-end"
}
const _hoisted_37 = { class: "float-end" }
const _hoisted_38 = {
  key: 0,
  class: "float-end"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner")
  const _component_b_pagination = _resolveComponent("b-pagination")
  const _component_b_col = _resolveComponent("b-col")
  const _component_b_button = _resolveComponent("b-button")
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")
  const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider")
  const _component_b_dropdown_form = _resolveComponent("b-dropdown-form")
  const _component_b_dropdown = _resolveComponent("b-dropdown")
  const _component_b_button_group = _resolveComponent("b-button-group")
  const _component_b_tooltip = _resolveComponent("b-tooltip")
  const _component_b_row = _resolveComponent("b-row")
  const _component_b_form_input = _resolveComponent("b-form-input")
  const _component_v_multiselect = _resolveComponent("v-multiselect")
  const _component_b_table = _resolveComponent("b-table")
  const _component_b_overlay = _resolveComponent("b-overlay")
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")
  const _component_b_modal = _resolveComponent("b-modal")
  const _directive_b_modal = _resolveDirective("b-modal")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_overlay, {
      show: $data.isLoading || $data.isExporting,
      "no-center": ""
    }, {
      overlay: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_b_spinner, { class: "align-middle" })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_b_row, { class: "mb-1" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, { cols: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_pagination, {
                  modelValue: $data.currentPage,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.currentPage) = $event)),
                  "total-rows": $options.totalRows,
                  "per-page": $data.perPage,
                  "aria-controls": "my-table",
                  onInput: $options.computeStickyColumnOffsets
                }, null, 8 /* PROPS */, ["modelValue", "total-rows", "per-page", "onInput"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_b_col, { cols: "4" }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_2, _toDisplayString($options.totalRows) + " Fälle / " + _toDisplayString($options.headsCount) + " Köpfe ", 1 /* TEXT */),
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($data.filters), (key) => {
                    return (_openBlock(), _createElementBlock("span", { key: key }, [
                      ($data.filters[key].type === 'multiselect' && $data.filters[key].value.length)
                        ? (_openBlock(), _createBlock(_component_b_button, {
                            key: 0,
                            class: "filter-button",
                            onClick: $event => ($options.clearFilter(key))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($options.getLabel(key)) + " ", 1 /* TEXT */),
                              _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */))
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                        : ($data.filters[key].type !== 'multiselect' && $data.filters[key].value !== '')
                          ? (_openBlock(), _createBlock(_component_b_button, {
                              key: 1,
                              class: "filter-button",
                              onClick: $event => ($options.clearFilter(key))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($options.getLabel(key)) + " ", 1 /* TEXT */),
                                _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */))
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                          : _createCommentVNode("v-if", true)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_b_col, { cols: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_button_group, { class: "float-end" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_button, {
                      onClick: _cache[1] || (_cache[1] = $event => ($options.toggleExmatriculated()))
                    }, {
                      default: _withCtx(() => [
                        (!$data.showExmatriculated)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [...(_cache[11] || (_cache[11] = [
                              _createElementVNode("i", { class: "fas fa-eye" }, null, -1 /* CACHED */),
                              _createElementVNode("span", { class: "d-none d-xl-inline-block" }, " Exmatrikulierte anzeigen", -1 /* CACHED */)
                            ]))]))
                          : _createCommentVNode("v-if", true),
                        ($data.showExmatriculated)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [...(_cache[12] || (_cache[12] = [
                              _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
                              _createElementVNode("span", { class: "d-none d-xl-inline-block" }, " Exmatrikulierte verbergen", -1 /* CACHED */)
                            ]))]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _withDirectives((_openBlock(), _createBlock(_component_b_button, { id: "btn-copy-mails" }, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createElementVNode("i", { class: "fas fa-envelope" }, null, -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })), [
                      [_directive_b_modal, 'email-modal']
                    ]),
                    _createVNode(_component_b_dropdown, {
                      id: "btn-choose-columns",
                      "auto-close": "outside",
                      right: "",
                      class: "btn-group"
                    }, {
                      "button-content": _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createElementVNode("i", { class: "fas fa-th-list" }, null, -1 /* CACHED */)
                      ]))]),
                      default: _withCtx(() => [
                        _createVNode(_component_b_dropdown_form, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_checkbox, {
                              id: "columnCheckbox",
                              switch: "",
                              onChange: _cache[2] || (_cache[2] = $event => ($options.resetVisibleFields()))
                            }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createTextVNode(" Alle Spalten ", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_b_dropdown_divider),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.selectableFields, (field) => {
                              return (_openBlock(), _createBlock(_component_b_form_checkbox, {
                                key: field.key,
                                modelValue: field.visible,
                                "onUpdate:modelValue": $event => ((field.visible) = $event)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(field.label || field.key), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue"]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_b_button, {
                      id: "btn-export-enrolments",
                      onClick: _cache[3] || (_cache[3] = $event => ($options.downloadEnrolments()))
                    }, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("i", { class: "fas fa-download" }, null, -1 /* CACHED */),
                        _createElementVNode("i", { class: "fas fa-file-excel" }, null, -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_b_button, {
                      id: "btn-clear-filters",
                      title: "Alle Filter löschen",
                      onClick: _cache[4] || (_cache[4] = $event => ($options.clearFilters()))
                    }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
                        _createElementVNode("i", { class: "fas fa-filter" }, null, -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                ($data.enrolmentsSelected.length)
                  ? (_openBlock(), _createBlock(_component_b_tooltip, {
                      key: 0,
                      target: "btn-copy-mails",
                      triggers: "hover"
                    }, {
                      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                        _createTextVNode(" E-Mail Adressen der ausgewählten Einschreibungen anzeigen ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }))
                  : (_openBlock(), _createBlock(_component_b_tooltip, {
                      key: 1,
                      target: "btn-copy-mails",
                      triggers: "hover"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" E-Mail Adressen " + _toDisplayString($options.filteredEnrolments.length !== $data.enrolments.length ? 'der gefilterten' : 'aller') + " Einschreibungen anzeigen ", 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })),
                _createVNode(_component_b_tooltip, {
                  target: "btn-choose-columns",
                  triggers: "hover"
                }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode(" Anzuzeigende Spalten auswählen ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                ($data.enrolmentsSelected.length)
                  ? (_openBlock(), _createBlock(_component_b_tooltip, {
                      key: 2,
                      target: "btn-export-enrolments",
                      triggers: "hover"
                    }, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createTextVNode(" Ausgewählte Einschreibungen als Excel-Datei herunterladen ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }))
                  : (_openBlock(), _createBlock(_component_b_tooltip, {
                      key: 3,
                      target: "btn-export-enrolments",
                      triggers: "hover"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.filteredEnrolments.length !== $data.enrolments.length ? 'Gefilterte' : 'Alle') + " Einschreibungen als Excel-Datei herunterladen ", 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_b_table, {
            id: "enrolments-table",
            ref: "table",
            busy: $data.isLoading,
            "onUpdate:busy": _cache[8] || (_cache[8] = $event => (($data.isLoading) = $event)),
            class: "bootstrap-vue-table-borders",
            striped: "",
            hover: "",
            small: "",
            responsive: "",
            fixed: "",
            "sticky-header": "100%",
            "head-variant": "",
            items: $options.filteredEnrolments,
            "primary-key": "id",
            fields: $options.filteredFields,
            "per-page": $data.perPage,
            "current-page": $data.currentPage,
            selectable: "",
            "select-mode": "multi",
            "no-select-on-click": "",
            "onUpdate:selectedItems": $options.onRowSelected,
            onSortChanged: $options.computeStickyColumnOffsets
          }, {
            "head()": _withCtx(({ field }) => [
              _createElementVNode("div", {
                title: field.title
              }, _toDisplayString(field.label), 9 /* TEXT, PROPS */, _hoisted_7),
              _createElementVNode("div", null, [
                ($data.filters[field.key] && $data.filters[field.key].type === 'string-contains')
                  ? (_openBlock(), _createBlock(_component_b_form_input, {
                      key: 0,
                      modelValue: $data.filters[field.key].value,
                      "onUpdate:modelValue": $event => (($data.filters[field.key].value) = $event),
                      type: "text",
                      size: "sm",
                      placeholder: "Suchen...",
                      debounce: "200",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("v-if", true),
                ($data.filters[field.key] && $data.filters[field.key].type === 'string-equals')
                  ? (_openBlock(), _createBlock(_component_b_form_input, {
                      key: 1,
                      modelValue: $data.filters[field.key].value,
                      "onUpdate:modelValue": $event => (($data.filters[field.key].value) = $event),
                      type: "text",
                      size: "sm",
                      placeholder: "Gleich...",
                      debounce: "200",
                      onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("v-if", true),
                ($data.filters[field.key] && $data.filters[field.key].type === 'multiselect')
                  ? (_openBlock(), _createBlock(_component_v_multiselect, {
                      key: 2,
                      modelValue: $data.filters[field.key].value,
                      "onUpdate:modelValue": $event => (($data.filters[field.key].value) = $event),
                      options: $data.filters[field.key].dynamicOptions,
                      multiple: true,
                      "track-by": "id",
                      "close-on-select": false,
                      "show-pointer": false,
                      "custom-label": $options.multiselectLabelGenerator,
                      "selected-label": "✓",
                      placeholder: "Filtern...",
                      onOpen: $event => ($options.calculateDynamicFilterOptions(field.key)),
                      onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                    }, {
                      selection: _withCtx(({ values, isOpen }) => [
                        (values.length > 1 && !isOpen)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(values.length) + " Werte", 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        (values.length === 1 && !isOpen)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(values[0].short || values[0].name), 1 /* TEXT */))
                          : (_openBlock(), _createElementBlock("span", _hoisted_10))
                      ]),
                      beforeList: _withCtx(() => [
                        _createElementVNode("li", {
                          class: "multiselect__option",
                          onClick: $event => ($options.resetMultiselect($data.filters[field.key]))
                        }, [...(_cache[21] || (_cache[21] = [
                          _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
                          _createTextVNode(" Filter löschen ", -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_11)
                      ]),
                      noResult: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                        _createTextVNode(" Keine Inhalte gefunden. ", -1 /* CACHED */)
                      ]))]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "options", "custom-label", "onOpen"]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            "cell(select)": _withCtx(({ index, rowSelected}) => [
              _createVNode(_component_b_form_checkbox, {
                checked: rowSelected,
                inline: "",
                onChange: $event => ($options.toggleSelection(index))
              }, null, 8 /* PROPS */, ["checked", "onChange"])
            ]),
            "cell(s_name)": _withCtx(({ item, value }) => [
              (item['s_studentDetailsUrl'])
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: item['s_studentDetailsUrl'],
                    target: "_blank"
                  }, _toDisplayString(value), 9 /* TEXT, PROPS */, _hoisted_12))
                : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(value), 1 /* TEXT */))
            ]),
            "cell(s_email)": _withCtx(({ value }) => [
              value
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    title: value
                  }, [
                    ($data.filters['s_email'].value === '')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                          _createElementVNode("a", {
                            href: 'mailto:' + value
                          }, [...(_cache[23] || (_cache[23] = [
                            _createElementVNode("i", { class: "fas fa-envelope" }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_16)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, [
                          _createElementVNode("a", {
                            href: 'mailto:' + value
                          }, _toDisplayString(value), 9 /* TEXT, PROPS */, _hoisted_18)
                        ]))
                  ], 8 /* PROPS */, _hoisted_14))
                : _createCommentVNode("v-if", true)
            ]),
            "cell(s_address)": _withCtx(({ value }) => [
              _createElementVNode("span", _hoisted_19, _toDisplayString(value), 1 /* TEXT */)
            ]),
            "cell(s_rentals)": _withCtx(({ item, value }) => [
              (item['s_rentalUrls'])
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (elem, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("a", {
                          href: item['s_rentalUrls'][index]
                        }, _toDisplayString(elem), 9 /* TEXT, PROPS */, _hoisted_21)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (elem, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("span", null, _toDisplayString(elem), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
            ]),
            "cell(s_roomBookingGroups)": _withCtx(({item, value}) => [
              (item['s_roomBookingGroupUrls'])
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (name, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("a", {
                          href: item['s_roomBookingGroupUrls'][index],
                          target: "_blank"
                        }, _toDisplayString(name), 9 /* TEXT, PROPS */, _hoisted_24)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (name, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("span", null, _toDisplayString(name), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
            ]),
            "cell(s_recordingRoomBalance)": _withCtx(({ value, unformatted }) => [
              _createElementVNode("span", {
                class: "float-end",
                style: _normalizeStyle(unformatted < 0 ? 'color: red;' : '')
              }, _toDisplayString(value), 5 /* TEXT, STYLE */)
            ]),
            "cell(s_concertHallBalance)": _withCtx(({ value, unformatted }) => [
              _createElementVNode("span", {
                class: "float-end",
                style: _normalizeStyle(unformatted < 0 ? 'color: red;' : '')
              }, _toDisplayString(value), 5 /* TEXT, STYLE */)
            ]),
            "cell(e_degree)": _withCtx(({ item, value }) => [
              (item['s_enrolmentDetailsUrl'])
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: item['s_enrolmentDetailsUrl'],
                    target: "_blank"
                  }, _toDisplayString(value), 9 /* TEXT, PROPS */, _hoisted_26))
                : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(value), 1 /* TEXT */))
            ]),
            "cell(e_currentSemesterCount)": _withCtx(({ value }) => [
              _createElementVNode("span", _hoisted_28, _toDisplayString(value), 1 /* TEXT */)
            ]),
            "cell(e_count)": _withCtx(({ value }) => [
              _createElementVNode("span", _hoisted_29, _toDisplayString(value), 1 /* TEXT */)
            ]),
            "cell(e_examinationRegulationTor)": _withCtx(({ item, value }) => [
              _createElementVNode("div", _hoisted_30, [
                (item['s_torDetailsUrl'])
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: item['s_torDetailsUrl'],
                      target: "_blank"
                    }, _toDisplayString(value), 9 /* TEXT, PROPS */, _hoisted_31))
                  : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(value), 1 /* TEXT */))
              ])
            ]),
            "cell(e_additionalSemesterCountMajor)": _withCtx(({ value }) => [
              _createElementVNode("span", _hoisted_33, _toDisplayString(value), 1 /* TEXT */)
            ]),
            "cell(e_teachingClaimMajor)": _withCtx(({ value }) => [
              (value>=0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(value), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            "cell(e_additionalSemesterCountSupplement)": _withCtx(({ value }) => [
              _createElementVNode("span", _hoisted_35, _toDisplayString(value), 1 /* TEXT */)
            ]),
            "cell(e_teachingClaimSupplement)": _withCtx(({ value }) => [
              (value>=0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(value), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            "cell(e_additionalSemesterCountMinor)": _withCtx(({ value }) => [
              _createElementVNode("span", _hoisted_37, _toDisplayString(value), 1 /* TEXT */)
            ]),
            "cell(e_teachingClaimMinor)": _withCtx(({ value }) => [
              (value>=0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(value), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            "table-busy": _withCtx(() => [...(_cache[24] || (_cache[24] = [
              _createElementVNode("div", { class: "text-center text-danger my-2" }, [
                _createElementVNode("strong", null, "Lade Einschreibungen...")
              ], -1 /* CACHED */)
            ]))]),
            empty: _withCtx(() => [...(_cache[25] || (_cache[25] = [
              _createElementVNode("h4", null, "Es sind keine Einschreibungen vorhanden?!", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["busy", "items", "fields", "per-page", "current-page", "onUpdate:selectedItems", "onSortChanged"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"]),
    _createVNode(_component_b_modal, {
      id: "email-modal",
      title: "E-Mail Adressen",
      "ok-only": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_form_textarea, { "model-value": $options.combinedMailAddresses }, null, 8 /* PROPS */, ["model-value"])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}